import { IS_DEV } from "@/config";
import type { PropsWithChildren } from "react";
import {
  PROJECT_ROLES,
  useHasRole,
  useIsAdmin,
  useIsOwner,
  useIsProjectTechnicalWriter,
  useIsProjectWriter,
  useIsSuperAdmin,
} from "./permissions";
import { Protected } from "./protected";

const isLocalhost = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
};

export const SuperAdminGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={useIsSuperAdmin}
    {...props}
  />
);
export const AdminGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={useIsAdmin}
    {...props}
  />
);
export const OwnerGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={useIsOwner}
    {...props}
  />
);
export const ReleaseManagerGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={() => useHasRole("release-manager")}
    {...props}
  />
);
export const ProjectWriterGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={useIsProjectWriter}
    {...props}
  />
);
export const ProjectTechnicalWriterGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={useIsProjectTechnicalWriter}
    {...props}
  />
);
export const ProjectGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={() => useHasRole(PROJECT_ROLES)}
    {...props}
  />
);
export const LocalhostGuard: React.FC<PropsWithChildren> = (props) => (
  <Protected
    useGuard={() => IS_DEV && isLocalhost()}
    {...props}
  />
);
